import UploadPromotionSaleField from './UploadPromotionSaleField'
import withUploadPromotionSaleField from './withUploadPromotionSaleField'

const ConnectedUploadPromotionSaleField = withUploadPromotionSaleField(
  UploadPromotionSaleField
)

export { ConnectedUploadPromotionSaleField as UploadPromotionSaleField }
